import { BrandThemeProvider } from '@montugroup/themes';
import Receipt from '@mui/icons-material/Receipt';
import { Link as RouterLink } from 'react-router-dom';

import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';
import { PATIENT_REFILL_ROUTE } from '@/routes/route-paths';
import { tmpSxSpecificityForce } from '@montugroup/circuit-shared/theme';
import { Box, Button } from '@montugroup/design-system';

export function CTASection() {
  const { key } = usePortalPartnerBrand();
  return (
    <BrandThemeProvider theme={key}>
      <Box marginBottom={6}>
        <Button
          component={RouterLink}
          to={PATIENT_REFILL_ROUTE}
          size="large"
          variant="contained"
          startIcon={<Receipt />}
          sx={{
            padding: (theme) => `${theme.spacing(4, 10)} ${tmpSxSpecificityForce}`,
            width: { xs: '100%', md: 'auto' },
          }}
        >
          Start your order
        </Button>
      </Box>
    </BrandThemeProvider>
  );
}

export default CTASection;
